'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var type = function type(value) {
  if (value instanceof Array) {
    return 'array';
  }
  return typeof value === 'undefined' ? 'undefined' : _typeof(value);
};

module.exports = type;


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/value/type.js
// module id = 78
// module chunks = 37